/* The notification facts a row reads (nine-answers item 7, 08/10): small readers over the feed so Campagnes,
   the campaign page and Cadeaux agree on which fact applies to which row. Items come newest first, so `find`
   is the latest. Dates print in Europe/Paris, the merchant's clock (one-clock rule: the server's quota month
   is UTC, a line only ever names the day a fact happened). */
import type { NotificationItem, NotificationsFeed } from '@/lib/api'

/** « 7 oct. » — the day, in Paris, of an ISO timestamp (the string itself if it is not a date). */
export function jourParis(at: string): string {
  const d = new Date(at)
  return Number.isNaN(d.getTime()) ? at : d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', timeZone: 'Europe/Paris' })
}
/** N1 · the workspace's quota pause (plans.js): one fact for every campaign that serves. A server that names a
    campaign narrows it to that row. */
export const quotaPause = (feed?: NotificationsFeed): NotificationItem | null => feed?.items.find(i => i.kind === 'quota_paused') ?? null
export const pausedByQuota = (feed: NotificationsFeed | undefined, campaignId: string): NotificationItem | null => {
  const q = quotaPause(feed)
  return q && (!q.campaignId || q.campaignId === campaignId) ? q : null
}
/** N4 · the campaign's end, when the feed still carries it (7 days by default, 30 at most). */
export const endedItem = (feed: NotificationsFeed | undefined, campaignId: string): NotificationItem | null =>
  feed?.items.find(i => i.kind === 'campaign_ended' && i.campaignId === campaignId) ?? null
/** N2 · a gift type at its month cap — the draw moved on to the other slices; the cap resets on the 1st. */
export const cappedItem = (feed: NotificationsFeed | undefined, giftTypeId: string): NotificationItem | null =>
  feed?.items.find(i => i.kind === 'slice_capped' && i.giftTypeId === giftTypeId) ?? null
export const CAPPED_LINE = 'plafond atteint ce mois · reprend le 1ᵉʳ'
